module.exports = "\n<app-project-box *ngFor='let p of projects.list' [project]='p'></app-project-box>\n\n  \n"


//////////////////
// WEBPACK FOOTER
// ./src/app/project-dashboard/project-dashboard.component.html
// module id = 435
// module chunks = 0